import { render, staticRenderFns } from "./secSchoolInfo.vue?vue&type=template&id=1483e084&scoped=true&"
import script from "./secSchoolInfo.vue?vue&type=script&lang=js&"
export * from "./secSchoolInfo.vue?vue&type=script&lang=js&"
import style0 from "./secSchoolInfo.vue?vue&type=style&index=0&id=1483e084&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1483e084",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VChip,VCol,VLayout,VRow,VSelect,VTextField})
